import React, { useState, useEffect, useContext } from 'react'
import { useStyles } from './ModalImportacao.styles'
import { Grid } from '@material-ui/core'
import { useVestigioService } from 'hooks/useVestigioService'
import { useRequisicaoService } from 'hooks/useRequisicaoService'
import { usePericiandoService } from 'hooks/usePericiandoService'
import { useVeiculoService } from 'hooks/useVeiculoService'
import { useCasoService } from 'hooks/useCasoService'
import { ModalConfirmacao } from 'components/ModalConfirmacao'
import { SelectVestigio } from 'components/SelectVestigio'
import { SelectRequisicao } from 'components/SelectRequisicao'
import { SelectPericiando } from 'components/SelectPericiando'
import { SelectVeiculo } from 'components/SelectVeiculo'
import { DetalhesCasoContext } from '../DetalhesCasoContext'

export const ModalImportacao = (props) => {
  const { aberto, setAberto, titulo, setMensagensAlerta, fetchCaso, setOpenAlert } = props
  const classes = useStyles()
  const context = useContext(DetalhesCasoContext)
  const vestigioService = useVestigioService()
  const requisicaoService = useRequisicaoService()
  const periciandoService = usePericiandoService()
  const veiculoService = useVeiculoService()
  const casoService = useCasoService()
  
  const [vestigiosImportar, setVestigiosImportar] = useState([])
  const [requisicaoImportar, setRequisicaoImportar] = useState([])
  const [veiculosImportar, setVeiculosImportar] = useState([])
  const [periciandosImportar, setPericiandosImportar] = useState([])
  const [processandoImportar, setProcessandoImportar] = useState(false)
  const [processandoVestigios, setProcessandoVestigios] = useState(false)
  const [processandoRequisicoes, setProcessandoRequisicoes] = useState(false)
  const [processandoVeiculos, setProcessandoVeiculos] = useState(false)
  const [processandoPericiandos, setProcessandoPericiandos] = useState(false)

  const isDisabled = !vestigiosImportar.length && !requisicaoImportar.length && !periciandosImportar.length && !veiculosImportar.length

  const handleConfirmarImportarObjetos = async () => {
    const novasMensagensAlerta = []
    if (vestigiosImportar.length > 0) {
      await vestigioService.importarVestigiosNoCaso(context.caso.id, vestigiosImportar, setProcessandoImportar)
    }
    if (requisicaoImportar.length > 0) {
      const caso = await casoService.listarCasoPorIdentificadorRIP(requisicaoImportar[0].identificador_caso_rip)
      if (caso != null && caso.id != context.caso.id) {
        novasMensagensAlerta.push(`Já existe o caso (${caso.identificador}) criado com esse RIP`)
      }
      if (novasMensagensAlerta.length) {
        setMensagensAlerta(novasMensagensAlerta.map((mensagem) => mensagem))
        setOpenAlert(true)
      } else {
        setMensagensAlerta([])
        await requisicaoService.importarRequisicaoNoCaso(context.caso.id, requisicaoImportar, setProcessandoImportar)
      }
    }
    if (veiculosImportar.length > 0) {
      await veiculoService.importarVeiculosNoCaso(context.caso.id, veiculosImportar, setProcessandoImportar)
    }
    if (periciandosImportar.length > 0) {
      await periciandoService.importarPericiandosNoCaso(context.caso.id, periciandosImportar, setProcessandoImportar)
    }

    setAberto(false)
    fetchCaso()
  }

  // Clear selections when modal closes
  useEffect(() => {
    if (!aberto) {
      setVestigiosImportar([])
      setRequisicaoImportar([])
      setVeiculosImportar([])
      setPericiandosImportar([])
    }
  }, [aberto])

  useEffect(() => {
    const casoRIP = context.caso?.identificador_caso_rip
    let rip = requisicaoImportar.length > 0 ? requisicaoImportar[0]?.identificador_caso_rip : null

    const novasMensagensAlerta = []
    requisicaoImportar.forEach((requisicao) => {
      if (requisicao?.status === 'EM_PROCESSAMENTO' || requisicao?.id_caso != null) {
        requisicaoImportar.pop(requisicao)
        novasMensagensAlerta.push(`A requisição ${requisicao.identificador} já pertence a outro caso.`)
      } else {
        if (casoRIP != null) {
          if (requisicao.identificador_caso_rip != casoRIP) {
            requisicaoImportar.pop(requisicao)
            novasMensagensAlerta.push(`A requisição ${requisicao.identificador} precisa ter o mesmo Identificador RIP do caso`)
          }
        }
        if (rip != null && requisicao.identificador_caso_rip != rip) {
          requisicaoImportar.pop(requisicao)
          novasMensagensAlerta.push(`As requisições selecionadas devem possuir o mesmo Identificador RIP`)
        }
      }
    })

    if (novasMensagensAlerta.length) {
      setMensagensAlerta(novasMensagensAlerta.map((mensagem) => mensagem))
      setOpenAlert(true)
    } else {
      setMensagensAlerta([])
    }
  }, [requisicaoImportar])

  if (!context.caso) return null

  return (
    <ModalConfirmacao
      aberto={aberto}
      disabled={isDisabled}
      onClose={() => setAberto(false)}
      onConfirm={handleConfirmarImportarObjetos}
      processando={processandoImportar}
      titulo={titulo}
      maxWidth="md"
    >
      {aberto && (
        <Grid container spacing={2}>
          <Grid item md={12} sm={12} xs={12} className={classes.item}>
            <SelectRequisicao requisicoesExternos={requisicaoImportar} setRequisicoesExternos={setRequisicaoImportar} setProcessando={setProcessandoRequisicoes} label="REQUISIÇÃO - Filtre pelo Identificador" multiplo={true} />
          </Grid>
          <Grid item md={12} sm={12} xs={12} className={classes.item}>
            <SelectVestigio vestigiosExternos={vestigiosImportar} setVestigiosExternos={setVestigiosImportar} setProcessando={setProcessandoVestigios} label="VESTÍGIO - Filtre pelo identificador ou descrição" multiplo idCaso={context.caso.id} />
          </Grid>
          <Grid item md={12} sm={12} xs={12} className={classes.item}>
            <SelectVeiculo veiculosExternos={veiculosImportar} setVeiculosExternos={setVeiculosImportar} setProcessando={setProcessandoVeiculos} label="VEÍCULO - Filtre pelo identificador, placa ou descrição" idCaso={context.caso.id} />
          </Grid>
          <Grid item md={12} sm={12} xs={12} className={classes.item}>
            <SelectPericiando periciandosExternos={periciandosImportar} setPericiandosExternos={setPericiandosImportar} setProcessando={setProcessandoPericiandos} label="PERICIANDO - Filtre pelo nome, alcunha ou CPF" idCaso={context.caso.id} />
          </Grid>
        </Grid>
      )}
    </ModalConfirmacao>
  )
}
